import * as Yup from 'yup';
import { isValidPhone } from '@copybet/core';

export const getBirthMinDate = () => {
  const date = new Date();
  date.setFullYear(date.getFullYear() - 100);
  return date;
};

export const getBirthMaxDate = () => {
  const date = new Date();
  date.setFullYear(date.getFullYear() - 18);
  return date;
};

export const ADDRESS_Q_MIN_LENGTH = 6;

const gbgValidator = (t: (key: string) => string) =>
  Yup.object().shape({
    firstName: Yup.string()
      .label(t('screen.gbg.verification.form.name'))
      .required(t('screen.gbg.verification.form.name.required'))
      .test('valid-length', t('screen.gbg.verification.form.name.min'), (value) => value?.trim().length === 0 || value?.trim().length >= 2)
      .matches(/^[^\d]*$/, t('screen.gbg.verification.form.name.no.numbers')),
    lastName: Yup.string()
      .label(t('screen.gbg.verification.form.surname'))
      .required(t('screen.gbg.verification.form.surname.required'))
      .test('valid-length', t('screen.gbg.verification.form.surname.min'), (value) => value?.trim().length === 0 || value?.trim().length >= 2)
      .matches(/^[^\d]*$/, t('screen.gbg.verification.form.surname.no.numbers')),
    birthDate: Yup.date()
      .label(t('screen.gbg.verification.form.date.of.birth'))
      .transform((value, originalValue) => (originalValue === '' ? null : value))
      .nullable()
      .required(t('screen.gbg.verification.form.birthdate.required'))
      .max(getBirthMaxDate(), t('screen.gbg.verification.form.birthdate.max'))
      .min(getBirthMinDate(), t('screen.gbg.verification.form.birthdate.min')),
    addressId: Yup.string()
      .nullable()
      .test('address-required', t('screen.gbg.verification.address.required'), function (value) {
        const { manualAddress } = this.parent;
        const hasManualAddress = manualAddress?.building?.trim() && manualAddress?.street?.trim() && manualAddress?.city?.trim() && manualAddress?.postalCode?.trim();
        return Boolean(value || hasManualAddress);
      }),
  });

// Kept out of gbgValidator itself: that schema is shared with the sign-up flow
// (auth.sign-up.tsx / api.v1.auth.registration.complete.ts), which validates its
// phone separately. Concat this only where the form actually has a phone field.
export const gbgPhone = (t: (key: string) => string) =>
  Yup.object().shape({
    phone: Yup.string()
      .trim()
      .label(t('sign.up.form.phone.label'))
      .test('phone', t('sign.up.form.phone.invalid'), (value) => !value || isValidPhone(value))
      .required(t('sign.up.form.phone.required')),
  });

export const gbgManualAddress = (t: (key: string) => string) =>
  Yup.object().shape({
    building: Yup.string().required(t('screen.gbg.verification.manually.address.building.required')),
    street: Yup.string().required(t('screen.gbg.verification.manually.address.street.required')),
    city: Yup.string().required(t('screen.gbg.verification.manually.address.city.required')),
    postalCode: Yup.string().required(t('screen.gbg.verification.manually.address.post.code.required')),
  });

export default gbgValidator;
